import {
  formatDeliveryTime,
  IN_STOCK_DELIVERY_LABEL,
} from '@/utils/format/formatDeliveryTime'

import cn from './DeliveryTime.module.scss'

const NOT_AVAILABLE = '-'
const TODAY_LABEL = 'сегодня'

interface DeliveryTimeProps {
  minDays: number | null | undefined
  maxDays: number | null | undefined
  outOfStock?: boolean
}

function DeliveryTime({
  minDays,
  maxDays,
  outOfStock = false,
}: DeliveryTimeProps) {
  const text = formatDeliveryTime(minDays, maxDays)

  if (outOfStock) {
    if (text === NOT_AVAILABLE) return <>{NOT_AVAILABLE}</>
    const ifAvailable = text === IN_STOCK_DELIVERY_LABEL ? TODAY_LABEL : text
    return (
      <span className={cn.outOfStock}>
        <span>{NOT_AVAILABLE}</span>
        <span className={cn.ifAvailable}>{`при наличии - ${ifAvailable}`}</span>
      </span>
    )
  }

  if (text === IN_STOCK_DELIVERY_LABEL) {
    return <span className={cn.inStock}>{text}</span>
  }
  return <>{text}</>
}

export default DeliveryTime
